<script>
export default {
    directives: {
        indicator: {
            bind(el, binding) {
                let color

                if (binding.value && binding.arg) {
                    color = binding.arg
                } else {
                    color = binding.value
                }

                el.classList.add(`indicator-${color}`)
            }
        }
    },
    props: {
        patient: {
            type: Object,
            required: true
        },
        showDaysTillEndOfSubscription: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            showProgressCells: 'weight'
        }
    },
    computed: {
        matrix() {
            return this.patient.data.matrix
        },
        data() {
            return this.patient.data
        }
    },
    mounted() {
        Vuemit.listen('Cells--select', (type) => {
            this.showProgressCells = type
        })
    },
    methods: {
        initiateGraph(type) {
            const graptData = this.patient.data[type].graph

            if (graptData.length === 0) {
                return
            }

            const getOrCreateTooltip = (chart) => {
                let tooltipEl = document.getElementById('chartjs-tooltip')

                if (!tooltipEl) {
                    tooltipEl = document.createElement('div')
                    tooltipEl.id = 'chartjs-tooltip'
                    tooltipEl.innerHTML = "<div class='tooltip-content'></div><span class='tooltip-line'></span>"
                    tooltipEl.style.opacity = 1
                    tooltipEl.style.pointerEvents = 'none'
                    tooltipEl.style.position = 'absolute'

                    document.body.appendChild(tooltipEl)
                }

                return tooltipEl
            }

            const externalTooltipHandler = (context) => {
                // Tooltip Element
                const { chart, tooltip } = context
                const tooltipEl = getOrCreateTooltip(Chart)

                // Hide if no tooltip
                if (tooltip.opacity === 0) {
                    tooltipEl.style.opacity = 0
                    return
                }

                function getBody(bodyItem) {
                    return bodyItem.lines
                }

                if (type === 'weight_progress') {
                    var unit = 'kg'
                } else {
                    var unit = 'cm'
                }

                // Set Text
                if (tooltip.body) {
                    const titleLines = tooltip.title || []
                    let bodyLines = tooltip.body.map(getBody)
                    bodyLines = bodyLines.toString().replace('.', ',')

                    const innerHtml = '<strong>' + bodyLines + ' ' + unit + '</strong> ' + moment(titleLines[0], 'MMMM Do YYYY, h:mm:ss a').format('D. MMMM')

                    const tableRoot = tooltipEl.querySelector('.tooltip-content')
                    tableRoot.innerHTML = innerHtml
                }

                const position = chart.canvas.getBoundingClientRect()
                const line = tooltipEl.querySelector('.tooltip-line')

                const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1

                tooltipEl.style.left = position.left + window.pageXOffset + tooltip.caretX + 'px'
                tooltipEl.style.top = position.top + window.pageYOffset + tooltip.caretY + 'px'

                line.style.position = 'absolute'
                line.style.left = position.left + window.pageXOffset + tooltip.caretX + 'px'
                line.style.height = tooltip.caretY + 4 + 'px'
            }

            // Prepare background and border colors for the graph
            const pointBackgroundColors = graptData.map((item, index) => {
                const previosValue = index !== 0 ? graptData[index - 1].value : item.value

                if (previosValue - item.value < 0) {
                    return '#FF3E57' // red
                } else if (previosValue === item.value) {
                    return 'rgb(103,100,134)' // grey
                } else {
                    return '#00A671' // green
                }
            })

            const labels = graptData.map((v) => Date.parse(v.date.date.replace(/ /g, 'T')));

            const minDate = Math.min(...labels);
            const maxDate = Math.max(...labels);

            const adjustedMaxDate = maxDate + 24 * 60 * 60 * 1000;

            new Chart($(this.$el).find(`.${type.replace('_', '-')}-graph`)[0], {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: graptData.map((v) => v.value),
                            pointBackgroundColor: pointBackgroundColors,
                            pointBorderColor: '#fff'
                        }
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: 10
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        x: {
                            type: 'time',
                            display: false,
                            time: {
                                displayFormats: {
                                    day: 'D. MMMM',
                                }
                            },
                            offset: true,
                            min: minDate,
                            max: adjustedMaxDate,
                        },
                        y: {
                            display: false,
                        }
                    },
                    elements: {
                        point: {
                            radius: 5,
                            hoverRadius: 5,
                            backgroundColor: [
                                'rgb(255, 0, 255)'
                            ],
                            borderColor: [
                                'rgba(255, 255, 255, 1)'
                            ],
                            pointStyle: 'circle',
                            borderWidth: 2,
                            hoverBorderWidth: 2,
                            hitRadius: 3
                        },
                        line: {
                            tension: 0,
                            borderWidth: 2,
                            borderColor: [
                                'rgb(103,100,134)'
                            ],
                            backgroundColor: [
                                'rgba(149,149,149,0)'
                            ],
                            spanGaps: true
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            // Disable the on-canvas tooltip
                            enabled: false,
                            external: externalTooltipHandler
                        }
                    }
                }
            })
        },
        round(number) {
            return Math.round((number + Number.EPSILON) * 10) / 10
        },
        numberFormat(num) {
            return Math.abs(num).toLocaleString('cs-CZ', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        }
    }
}
</script>
